import React from 'react';

import { v4 as uuid } from 'uuid';

import { generateMessageTemplateKey } from 'hooks';

import MessageMultipleChoice, { MessageMultipleChoiceProps } from './MessageMultipleChoice';
import { TMessageWrapper } from './MessageWrapper';

export interface Message2FAProps extends Omit<MessageMultipleChoiceProps, 'classes'> {}

const Message2FA: React.FC<Message2FAProps> = ({ message, onSubmit, ...rest }) => {
  const metadata: TMessageWrapper['metadata'] = {
    ...message.metadata,
    action: 'send2FACode',
    item: {
      ...message.metadata.item!,
      properties: { answers: [{ id: uuid(), label: generateMessageTemplateKey('patientLumaBot2FASendCode') }] },
    },
  };

  // Reuse multiple choice to show the send code option
  return <MessageMultipleChoice message={{ ...message, metadata }} onSubmit={onSubmit} {...rest} />;
};

export default Message2FA;
